import {
    AccountSubtype,
    AccountType,
} from "@common/constants/domains/accounting/accounts";
import { useMutation } from "@tanstack/react-query";
import { useCreateAccountMutation } from "@api/account.api";

interface AccountToCreate {
    name: string;
    type: AccountType;
    subtype?: AccountSubtype;
    parentGroupId?: string | null;
}

interface BulkAccountCreationParams {
    entityId: number;
    accounts: AccountToCreate[];
}

export function useAccountCreation() {
    const createAccountMutation = useCreateAccountMutation();

    return useMutation({
        mutationFn: async ({
            entityId,
            accounts,
        }: BulkAccountCreationParams) => {
            const results = [];
            for (const account of accounts) {
                const result = await createAccountMutation.mutateAsync({
                    ...account,
                    entityIds: [entityId],
                });
                results.push(result);
            }
            return results;
        },
    });
}
